// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"d2370fe0","213":"cc119224","453":"ee5788f6"}[chunkId] + ".chunk.js";
};